import { get, put } from './APIClient';

module.exports = {
  getWallOfLove,
  updateWallOfLove,
  getPublicWallOfLove,
  getWallOfLoveAnalytics,
};

async function getWallOfLove(url, params) {
  const config = {};
  if(params) {
    config.params = params;
  }
  const res = await get(url, config);
  if(res.error) {
    throw res.error;
  }
  return res?.data || {};
}

function updateWallOfLove({ workspaceId, wallOfLove }) {
  return put(`/workspaces/${workspaceId}/wall-of-love`, wallOfLove);
}

async function getPublicWallOfLove({
  publicId, pageURL, preview, page, previewParams, visitorHeaders,
}) {
  if(!publicId) {
    return null;
  }
  const reqURL = `${process.env.NEXT_PUBLIC_API_BASE}/public/wall-of-love/${publicId}`;
  const params = {};
  if(preview) {
    params.preview = true;
  }
  if(pageURL) {
    params.url = pageURL;
  }
  if(page) {
    params.page = page;
  }
  if(previewParams) {
    Object.assign(params, previewParams);
  }
  const config = { params, withCredentials: false };
  if(visitorHeaders) {
    config.headers = Object.fromEntries(Object.entries(visitorHeaders).filter(([, value]) => value));
  }
  const res = await get(reqURL, config);
  if(res.error) {
    throw res.error;
  }
  return res && res.data ? res.data : {};
}

async function getWallOfLoveAnalytics(url, params) {
  const config = {};
  if(params) {
    config.params = params;
  }
  const res = await get(url, config);
  if(res.error) {
    throw res.error;
  }
  return res?.data || {};
}
